import { Badge } from "@/components/ui/badge";
import type { DmarcReportRow } from "@/types/email-auth";

interface ReportTableProps {
  reports: DmarcReportRow[];
}

function ResultBadge({ result }: { result: string }) {
  const variant = result === "pass" ? "default" : "destructive";
  const className = result === "pass" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800";
  return <Badge variant={variant} className={className}>{result}</Badge>;
}

export function ReportTable({ reports }: ReportTableProps) {
  if (reports.length === 0) {
    return (
      <p className="py-8 text-center text-sm text-muted-foreground">
        No DMARC reports uploaded yet. Upload an aggregate report to see sender analysis.
      </p>
    );
  }

  return (
    <div className="overflow-x-auto rounded-lg border">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b bg-muted/50">
            <th className="px-3 py-2 text-left font-medium">Source IP</th>
            <th className="px-3 py-2 text-left font-medium">Org</th>
            <th className="px-3 py-2 text-left font-medium">Domain</th>
            <th className="px-3 py-2 text-center font-medium">Messages</th>
            <th className="px-3 py-2 text-center font-medium">SPF</th>
            <th className="px-3 py-2 text-center font-medium">DKIM</th>
            <th className="px-3 py-2 text-center font-medium">Disposition</th>
          </tr>
        </thead>
        <tbody>
          {reports.map((r) => (
            <tr key={r.id} className="border-b last:border-0">
              <td className="px-3 py-2 font-mono text-xs">{r.source_ip}</td>
              <td className="px-3 py-2">{r.org_name || "-"}</td>
              <td className="px-3 py-2">{r.domain}</td>
              <td className="px-3 py-2 text-center">{r.message_count}</td>
              <td className="px-3 py-2 text-center"><ResultBadge result={r.spf_result} /></td>
              <td className="px-3 py-2 text-center"><ResultBadge result={r.dkim_result} /></td>
              <td className="px-3 py-2 text-center">
                <Badge variant="outline">{r.disposition}</Badge>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
